import { render, staticRenderFns } from "./clickShowTag.vue?vue&type=template&id=37fdb376&scoped=true"
import script from "./clickShowTag.vue?vue&type=script&lang=js"
export * from "./clickShowTag.vue?vue&type=script&lang=js"
import style0 from "./clickShowTag.vue?vue&type=style&index=0&id=37fdb376&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fdb376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fdb376')) {
      api.createRecord('37fdb376', component.options)
    } else {
      api.reload('37fdb376', component.options)
    }
    module.hot.accept("./clickShowTag.vue?vue&type=template&id=37fdb376&scoped=true", function () {
      api.rerender('37fdb376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clickShowTag.vue"
export default component.exports